export default __webpack_public_path__ + "static/media/litho-demo-corporate.5b865366.jpg";